import { gql } from '@apollo/client/core'

import {
  SERVER_ERROR,
  UNAUTHENTICATED_ERROR,
  UNAUTHORIZED_ERROR
} from '@base/api/fragments/errors'
import { ATTRIBUTE_FRAGMENT } from '@base/api/fragments/attribute'
import { CLUB_FRAGMENT } from '@base/api/fragments/club'

export const LIST_CLUBS_QUERY = gql`
  ${SERVER_ERROR}
  ${UNAUTHENTICATED_ERROR}
  ${UNAUTHORIZED_ERROR}
  ${ATTRIBUTE_FRAGMENT}
  ${CLUB_FRAGMENT}

  query listClubs(
    $filter: ListClubsFilter!
    $sortField: ClubSortField!
    $sortOrder: SortOrder!
    $offset: Int
    $limit: Int
    $randomize: Boolean
  ) {
    listClubs(
      filter: $filter
      sort: [{ sortField: $sortField, sortOrder: $sortOrder }]
      offset: $offset
      limit: $limit
      randomize: $randomize
    ) {
      ... on ListClubsOutput {
        clubs {
          ...Club,
          courses {
            ... on ListCoursesOutput {
              courses {
                courseName,
                numHoles,
                par,
                priceRange,
                gallery,
                slug
              }
            }
          }
        }
        count
      }
      ... on ListClubsErrorOutput {
        errors {
          clubName
          sort
          limit
          offset
        }
      }
      ...UnauthenticatedError
      ...UnauthorizedError
      ...ServerError
    }
  }
`
